//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '../../ui/alert';

interface IngestionBlockedBannerProps {
  isActive: boolean;
}

const IngestionBlockedBanner: React.FC<IngestionBlockedBannerProps> = ({
  isActive,
}) => {
  const { t } = useTranslation();
  if (!isActive) return null;
  return (
    <Alert data-testid="ingestion-blocked-banner" className="mb-1">
      <Info className="size-4" />
      <AlertDescription>
        {t(
          'ingestion-in-progress-banner',
          'MCP tool ingestion is in progress — Loop Genie will be available once it completes.',
        )}
      </AlertDescription>
    </Alert>
  );
};

export default IngestionBlockedBanner;
